import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { META_REDUCERS } from '@ngrx/store';
import { metaReducerFactoryWithOptions, ngrxStoreIdbServiceInitializer, optionsFactory } from './ngrx-store-idb.metareducer';
import { NgrxStoreIdbStoreProvider } from './ngrx-store-idb-store.provider';
import { NgrxStoreIdbOptions, OPTIONS } from './ngrx-store-idb.options';
import { RehydrateEffects } from './ngrx-store-idb.effects';
import { NgrxStoreIdbService } from './ngrx-store-idb.service';


/**
 * Import this module in your AppModule using forRoot() method to
 * enable synchornisation of redux store with IndexedDB.
 */
@NgModule({
  declarations: [],
  imports: [
    EffectsModule.forFeature([RehydrateEffects]),
  ],
  exports: [],
})
export class NgrxStoreIdbModule {

  constructor() {
    const parentModule = inject(NgrxStoreIdbModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error(
        'NgrxStoreIdbModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(options: Partial<NgrxStoreIdbOptions> = {}): ModuleWithProviders<NgrxStoreIdbModule> {
    return {
      ngModule: NgrxStoreIdbModule,
      providers: [
        // Used to pass options into RehydrateEffects
        {
          provide: OPTIONS,
          useValue: optionsFactory(options),
        },
        provideAppInitializer(() => {
        const initializerFn = (ngrxStoreIdbServiceInitializer)(inject(OPTIONS), inject(NgrxStoreIdbService), inject(NgrxStoreIdbStoreProvider));
        return initializerFn();
      }),
        // This installs NgrxStateIdb metareducer into use
        {
          provide: META_REDUCERS,
          deps: [OPTIONS, NgrxStoreIdbStoreProvider, NgrxStoreIdbService],
          useFactory: metaReducerFactoryWithOptions,
          multi: true,
        },
      ],
    };
  }
}
